import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback
} from "reactstrap";

const CreateChildModal = ({ show, handleClose, handleCreate }) => {
  const [childName, setChildName] = useState("");
  const [childDescription, setChildDescription] = useState("");
  const [touched, setTouched] = useState(false);

  const isNameValid = childName.trim().length >= 1;
  const showError = touched && !isNameValid;

  const handleSubmit = () => {
    setTouched(true);
    
    if (isNameValid) {
      handleCreate(childName, childDescription);
      setChildName("");
      setChildDescription("");
      setTouched(false);
      handleClose();
    }
  };

  return (
    <Modal isOpen={show} toggle={handleClose}>
      <ModalHeader toggle={handleClose}>
        <span style={{ fontSize: "18px" }}>Create Child</span>
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="childName">
              Child Name <span className="text-danger">*</span>
            </Label>
            <Input
              type="text"
              id="childName"
              value={childName}
              invalid={showError}
              onChange={(e) => {
                setChildName(e.target.value);
                setTouched(true);
              }}
              onBlur={() => setTouched(true)}
            />
            <FormFeedback>
              Child name is required
            </FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label for="childDescription">
              Description (Optional)
            </Label>
            <Input
              type="textarea"
              id="childDescription"
              rows={3}
              value={childDescription}
              onChange={(e) => setChildDescription(e.target.value)}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSubmit}
          className="create-button"
        >
          Create
        </Button>
        <Button
          color="secondary"
          onClick={handleClose}
          className="cancell-button cancell-button-container"
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateChildModal;